import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField
} from '@material-ui/core';
import { useState } from 'react';
import { ButtonWithPromise } from '../ButtonWithPromise';
import { DialogTitleWithTypography } from '../DialogTitleWithTypography';

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (name: string) => Promise<void>;
};

export const SaveViewModal = ({ open, onClose, onSave }: Props) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  const handleClose = () => {
    setName('');
    onClose();
  };

  const handleSave = async () => {
    if (saving) return;
    setSaving(true);
    try {
      await onSave(name.trim());
      setName('');
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitleWithTypography>Name your saved view</DialogTitleWithTypography>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && name.trim()) {
              e.preventDefault();
              handleSave();
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <ButtonWithPromise
          variant="contained"
          color="primary"
          disabled={!name.trim() || saving}
          onClick={handleSave}
          pending="Saving..."
        >
          Save
        </ButtonWithPromise>
      </DialogActions>
    </Dialog>
  );
};
